import React from "react";
import "./Benefits.css";


const Benefits = () => {
  return (
    <div className="benefit-container">
      <div className="benefit1">
        <div className="imagecontainer1">
          <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/chef2.webp" alt="#" />
        </div>
        <div className="imagecontainer2">
          <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/round.webp" alt="#" />
        </div>
        <div className="textarea">
          <h1>
            {" "}
            <p> Benefits of the Fry Right System </p>{" "}
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/redheaderimg.webp" alt="#" />
          </h1>
          <strong>Change the Culture of your Kitchen</strong>
          <p className="benefit1-text">
            Strengthen employee morale with a simple-to-use system that provides
            an easier way to control fried food quality and clean fryers. Due to
            our carbon elimination methodology, employees spend less time
            cleaning their fryers, which makes for happier employees. As their
            Quality Cycle<sup className=" TM">TM &nbsp;</sup>  grows, the natural result
            is the complete elimination of the times the Boil-Out job would need
            to be done.
          </p>
        </div>
      </div>
      <div className="benefit2">
        <div className="textarea">
          <h1>
            {" "}
            <p>Boil Out Elimination Example: </p>{" "}
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/headerBackground.webp" alt="#" />
          </h1>
          <div className=" list-card ">
            <div className="list-con">
              <ul>
                <li>
                  {" "}
                  <span></span> 7 day oil cycle is 4 oil change outs per month
                </li>
                <li>
                  <span></span>10 day oil cycle is 3 oil change outs per month
                </li>
                <li>
                  <span></span>14 day oil cycle is 2 oil change outs per month
                </li>
              </ul>
              <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/shortlogo.webp" alt="#" />
            </div>
            <div className="list-con1">
              <h2>Reduce Oil Consumption</h2>
              <p>
                The side effect of implementing The Fry Right System’s Quality
                Cycle<sup className=" TM">TM &nbsp;</sup>  is a reduction in oil
                Consumption.
              </p>
            </div>
          </div>
        </div>
        <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/foodpng1.webp" alt="#" className="plate" />
      </div>
    </div>
  );
};

export default Benefits;
